import amplitude from 'amplitude-js';
import config from '../config';
import { AmplitudeEventsCategories } from '../enums/amplitude.events';

type EventType = 'event';
type Priority = 'low' | 'normal' | 'high';
type Environment = 'iOS' | 'android' | 'web';

interface IEvent {
    name: string;
    payload?: {
        type: EventType;
        environment: Environment;
        category: AmplitudeEventsCategories[];
        propreties?: any;
        hasCustomerIO?: boolean;
        priority?: Priority;
        comment?: string;
    };
}

const amplitudeInstance = amplitude.getInstance();

export default class AnalyticsService {
    public static client: any;

    public static init() {
        amplitudeInstance.init(config.AMPLITUDE_API_KEY);
    }

    public static setUser(userId: string) {
        try {
            amplitudeInstance.setUserId(userId);
        } catch (error) {}
    }

    public static logEvent(event: IEvent) {
        try {
            amplitudeInstance.logEvent(event.name, event.payload);
        } catch (error) {}
    }
}
